import { Redirect } from "react-router-dom";
import { lazy } from "react";

//Constants
import {
  MAINTENANCE_PAGES_LIST,
  MAINTENANCE_MENU_OPTIONS_LIST,
  MAINTENANCE_MENU_GROUPS_LIST,
  MAINTENANCE_ACTIONS_LIST,
  MAINTENANCE_MENUS_LIST,
  MAINTENANCE_USERS_LIST,
  MAINTENANCE_ROLES_LIST,
  MAINTENANCE_USER_TYPES_LIST,
  INIT,
  UNATHORIZED,
  NOT_FOUND,
  LOGIN_PAGE,
  FORGETPASS,
  PRC_PRICE_GROUP_LIST,
  PRC_PAYMENT_METHOD_LIST,
  PRC_BIN_LIST,
  STO_STORE_LIST,
  STO_WAREHOUSE_LIST,
  CMP_ATTRIBUTE_VALUE_LIST,
  ACC_DAILY_INVOICES_REPORT_LIST,
  ACC_INVOICES_REPORT_LIST,
  ACC_STATUS_RESULT_REPORT_LIST,
  ACC_INVOICESXEMPLOYEE_GRUOPEDREPORT_LIST,
  ACC_INVOICESXEMPLOYEE_REPORT_LIST,
  ACC_OVERDUE_VENDOR_INVOICES_LIST,
  ACC_OVERDUE_CUSTOMER_INVOICES_LIST,
  ACC_JOURNAL_LIST,
  ACC_ENTRIES,
  ACC_MANUAL_MOVEMENTS,
  ACC_EXPENSES_LIST,
  ACC_INVOICES_LIST,
  ACC_QUOTATION_INVOICES_LIST,
  ACC_EXPENSES_PAYMENT_LIST,
  ACC_VENDOR_PAYMENT_INVOICES_LIST,
  ACC_QUOTATION_PAYMENT_INVOICES_LIST,
  INVOICE_TYPES_LIST,
  ERP_CREDIT_NOTES_LIST,
  ERP_CREDIT_NOTES_REPORT_LIST,
  POS_CLOSURE_REPORT_LIST,
  CUS_CUSTOMER_LIST,
  PRO_BASE_UNIT_MEASURE_LIST,
  PRO_CATEGORY_LIST,
  PRO_DIVISION_LIST,
  PRO_GROUP_LIST,
  PRO_IVA_LIST,
  PRO_PRODUCT_LIST,
  PRO_PRODUCT_CONTRIBUTION_MARGIN_LIST,
  UPLOAD_INVENTORY_ADJUSTMENT_LIST,
  UPLOAD_INVENTORY_LIST,
  PRO_SPECIAL_GROUP_LIST,
  OFF_VALIDATION_PERIOD_LIST,
  OFF_OFFER_LIST,
  OFF_MIX_AND_MATCH_LIST,
  OFF_OFFER_ON_DISCOUNT_LIST,
  CUS_MEMBER_CLUB_LIST,
  CUS_CUSTOMER_MEMBER_CLUB_LIST,
  CUS_GROUP_LIST,
  CUS_BUS_POSTING_GROUP_LIST,
  PRO_IVA_POSTING_GROUP_LIST,
  CUS_POSTING_GROUP_LIST,
  OFF_OFFER_PRIORITY_LIST,
  GEN_PAYMENT_TERM_LIST,
  GEN_ATTRIBUTE_LIST,
  LOC_COUNTRY_LIST,
  LOC_STATE_LIST,
  LOC_CITY_LIST,
  MAINTENANCE_AREA_LIST,
  MAINTENANCE_TABLE_LIST,
  MAINTENANCE_COMMANDS_LIST,
  PRO_BRAND_LIST,
  PRO_INVENTORY_GROUP_LIST,
  OFF_EMPLOYEE_DISCOUNT_LIST,
  PRO_ASSORTMENT_TREE_LIST,
  PRO_TYPE_LIST,
  PRO_PURCHASE_REQUEST_LIST,
  PRO_PURCHASE_RECEIPT_LIST,
  PRO_REQUISITION_LIST,
  PRO_IMPORT_COST_LIST,
  PRO_BILL_LADING_LIST,
  PRO_QUOTATION_LIST,
  PRO_MINMAX_ALERT_LIST,
  INV_WAREHOUSE_TRANSFER_LIST,
  INV_AVAILABLE_PRODUCTS_LIST,
  INV_MOVEMENTS_PRODUCTS_LIST,
  EMP_EMPLOYEE_LIST,
  EMP_EMPLOYEETYPE_LIST,
  PRO_WARRANTY_LIST,
  PRO_WARRANTY_FORMAT_LIST,
  PRO_WARRANTY_TREE_LIST,
  PRO_WARRANTY_MODEL_LIST,
  POS_TERMINAL_LIST,
  BUS_CURRENCY_LIST,
  PRO_VENDOR_POSTING_GROUP_LIST,
  PRO_VENDOR_LIST,
  PRC_PAYMENT_METHOD_GROUP_LIST,
  STO_ACCOUNT_SUBCATEGORY_LIST,
  STO_INCOME_EXPENSE_ACCOUNT_LIST,
  STO_LEDGER_ACCOUNT_LIST,
  BUS_SERIE_LIST,
  CFG_MODULE_LIST,
  CFG_CONFIGURATION_COMISION_LIST,
  CFG_SERIE_SETUP_LIST,
  INV_MOV_TYPE_LIST,
  INV_CREATE_LIST,
  PRC_GIFT_CARD_LIST,
  OFF_COUPON_LIST,
  OFF_COUPON_ISSUER_LIST,
  PRC_BANK_LIST,
  PRC_BANK_DEPOSIT_LIST,
  PRC_BANK_ACCOUNT_LIST,
  PRC_VENDOR_BANK_ACCOUNT_LIST,
  POS_MENU_PRODUCT_LIST,
  PRC_VOUCHER_LIST,
  PRC_VOUCHERTYPE_LIST,
  PRC_TERM_BC_LIST,
  CFG_CASH_DECLARATION_LIST,
  SAL_SALE_LIST,
  SAL_SALE_RETURN_REASON,
  INV_PRINT_REASON,
  RPT_CASH_RECEIPT_REPORT,
  RPT_PRODUCTS_SALES_REPORT,
  RPT_SALES_BY_CUSTOMER_REPORT,
  CUS_MEMBER_CLUB_CARD_SPOOL_LIST,
  USR_FINGER_REASON_LIST,
  USR_SUPERVISOR_PERMISSION_LIST,
  USR_USER_AH_LIST,
  USR_SPECIAL_ACCESS_USER_LIST,
  USR_DUALPAYMENTS_COMPANY_LIST,
  USR_DUALPAYMENTS_COMPANY_DETAIL,
  CFG_CONFIGURATION_LIST,
  CFG_CONFIGURATIONPRINTCOPIES_LIST,
  INF_INFO_CODE_LIST,
  OFF_OFFER_ON_DISCOUNT_CONFIGS_LIST,
  CONFIGURATION_MENU_LIST,
  STO_COMPANY_LIST,
  DOC_FORMAT_LIST,
  SAL_SALESTATUS_LIST,
  STO_TRANSACTION_TYPE_LIST,
  STO_SERVICE_CATEGORY_LIST,
  TIME_MEASUREMENT_LIST,
  CUS_MEMBER_CLUB_SCHEME_LIST,
  INV_VALORIZATION_PRODUCTS_LIST,
  GOR_DEPARMENT_TYPE_LIST,
  GOR_WORK_POSITION_TYPE_LIST,
  GOR_WORK_AREA_LIST,
  GOR_DEPARTMENT_LIST,
  GOR_WORK_POSITION_LIST,
  GOR_COST_CENTER_LIST,
  GOR_POSITION_LIST,
  GEX_TERMINATION_CATEGORY_LIST,
  GEX_TERMINATION_REASON_LIST,
  GEX_CONTRACT_TYPE_LIST,
  GEX_DOCUMENT_TYPE_LIST,
  GEX_PARENT_TYPE_LIST,
  GEX_INFO_EMPLOYEE_LIST,
  GEX_CONTRIBUTION_TYPE_LIST,
  GEX_CONTRIBUTION_EMPLOYEE_LIST,
  GEX_ACCOUNT_TYPE_LIST,
  GEX_PAYMENT_METHOD_LIST,
  MODIFIER_GROUP_LIST,
  POS_PRINTER_LIST
} from "src/constants/pagesRoutes";

//Dashboard
import Dashboard from "../pages/Dashboard";

//Authentication pages
import Login from "src/pages/Authentication/Login";
import Logout from "src/pages/Authentication/Logout";
import userProfile from "src/pages/Authentication/user-profile";

//Maintenance pages
import ForgetPassword from "src/pages/Authentication/ForgetPassword";

//Utility pages
import NotFound from "src/pages/Utility/NotFound";
import Unathorized from "src/pages/Utility/Unauthorized";
import LoginNew from "src/pages/Authentication/LoginNew";
import ForgetPasswordNew from "src/pages/Authentication/ForgetPasswordNew";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

/* Lazy Company Pages. */
const LazyAttributeValueListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAttributeValueListPage" */ "src/pages/Company/AttributeValueList/AttributeValueListPage"
    )
);

/* Lazy AccountDailyInvoicesReport Pages. */
const LazyAccountDailyInvoicesReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountDailyInvoicesReportListPage" */ "src/pages/Accounting/Reports/AccountingDailyInvoicesReportListPage"
    )
);

/* Lazy AccountInvoicesReport Pages. */
const LazyAccountInvoicesReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountInvoicesReportListPage" */ "src/pages/Accounting/Reports/AccountingInvoicesReportListPage"
    )
);

/* Lazy AccountStatusResultReport Pages. */
const LazyAccountStatusResultReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountStatusResultReportListPage" */ "src/pages/Accounting/Reports/AccountingStatusResultReportListPage"
    )
);

/* Lazy AccountInvoicesXEmployeeReport Pages. */
const LazyAccountInvoicesXEmployeeReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountInvoicesXEmployeeReportListPage" */ "src/pages/Accounting/Reports/AccountingInvoicesXEmployeeListPage"
    )
);

/* Lazy AccountInvoicesXEmployeeReport Pages. */
const LazyAccountInvoicesXEmployeeReportGroupedListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountInvoicesXEmployeeReportGroupedListPage" */ "src/pages/Accounting/Reports/AccountingInvoicesXEmployeeGroupedListPage"
    )
);

/* Lazy AccountOverDueInvoicesCustomer Pages. */
const LazyAccountOverDueInvoicesCustomerListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountOverDueInvoicesCustomerListPage" */ "src/pages/Accounting/Reports/AccountingCXCListPage"
    )
);

/* Lazy AccountOverDueInvoicesPartner Pages. */
const LazyAccountOverDueInvoicesPartnerListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountOverDueInvoicesPartnerListPage" */ "src/pages/Accounting/Reports/AccountingCXPListPage"
    )
);

/* Lazy AccountInvoices Pages. */
const LazyAccountJournalListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountJournalListPage" */ "src/pages/Accounting/Journal/JournalList/JournalListPage"
    )
);

const LazyAccountManualMovementListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountManualMovementListPage" */ "src/pages/Accounting/ManualSeats/ManualSeatList/ManualSeatListPage"
    )
);

const LazyAccountExpensesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountExpensesListPage" */ "src/pages/Accounting/Expenses/AccountExpenseList/AccountExpenseListPage"
    )
);

const LazyAccountEntriesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountEntriesListPage" */ "src/pages/Accounting/Reports/AccountingEntriesReportListPage"
    )
);

const LazyAccountInvoicesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountInvoicesListPage" */ "src/pages/Accounting/Invoice/InvoiceList/InvoiceListPage"
    )
);

const LazyAccountQuotationInvoicesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountQuotationInvoicesListPage" */ "src/pages/Accounting/Invoice/InvoiceClientList/InvoiceClientListPage"
    )
);

const LazyAccountQuotationPaymentInvoicesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountQuotationPaymentInvoicesListPage" */ "src/pages/Accounting/Invoice/InvoicePaymentList/InvoicePaymentListPage"
    )
);

const LazyAccountPaymentExpensesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountPaymentExpensesListPage" */ "src/pages/Accounting/Invoice/InvoiceExpensePaymentList/InvoiceExpensePaymentListPage"
    )
);

const LazyAccountPaymentInvoicesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountPaymentInvoicesListPage" */ "src/pages/Accounting/Invoice/InvoiceVendorPaymentList/InvoiceVendorPaymentListPage"
    )
);

const LazyInvoiceTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyInvoiceTypesListPage" */ "src/pages/Accounting/InvoiceTypes/InvoiceTypesList/InvoiceTypesListPage"
    )
);

const LazyERPCreditNotesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyERPCreditNotesListPage" */ "src/pages/Accounting/CreditNotes/CreditNoteList/CreditNoteListPage"
    )
);
const LazyERPCreditNotesReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyERPCreditNotesReportListPage" */ "src/pages/Accounting/Reports/AccountingCreditNoteReportListPage"
    )
);
const LazyClosurePOSReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyClosurePOSReportListPage" */ "src/pages/Accounting/Reports/ClosurePOSReportListPage"
    )
);
const LazySalesByProductReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySalesByProductReportListPage" */ "src/pages/Accounting/Reports/SalesByProductReportListPage"
    )
);

const LazySalesByCustomerGroupedReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySalesByCustomerGroupedReportListPage" */ "src/pages/Accounting/Reports/SalesByCustomerGroupedReportListPage"
    )
);
/* Lazy Customer Pages. */
const LazyCustomerListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCustomerListPage" */ "src/pages/Customers/CustomerList/CustomerListPage"
    )
);
const LazyMemberClubListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMemberClubListPage" */ "src/pages/Customers/MemberClubList/MemberClubListPage"
    )
);

const LazyCustomerXMemberClubListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCustomerListPage" */ "src/pages/Customers/CustomerXClubListPage/CustomerXClubListPage"
    )
);

const LazyCustomerGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCustomerGroupListPage" */ "src/pages/Customers/CustomerGroupList/CustomerGroupListPage"
    )
);
const LazyPostingGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPostingGroupListPage" */ "src/pages/Customers/PostingGroupList/PostingGroupListPage"
    )
);
const LazyMemberClubCardSpoolListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMemberClubCardSpoolListPage" */ "src/pages/Customers/MemberClubCardSpoolList/MemberClubCardSpoolListPage"
    )
);
const LazyMemberClubSchemeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMemberClubSchemeListPage" */ "src/pages/Customers/MemberClubSchemeList/MemberClubSchemeListPage"
    )
);
const LazyBillLadingListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBillLadingListPage" */ "src/pages/Products/BillLadingList/BillLadingListPage"
    )
);

/* Lazy Products Pages. */
const LazyCategoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCategoryListPage" */ "src/pages/Products/CategoryList/CategoryListPage"
    )
);
const LazyDivisionListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDivisionListPage" */ "src/pages/Products/DivisionList/DivisionListPage"
    )
);
const LazyInventoryGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyInventoryGroupListPage" */ "src/pages/Products/InventoryGroupList/InventoryGroupListPage"
    )
);
const LazyProductGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyProductGroupListPage" */ "src/pages/Products/GroupList/GroupListPage"
    )
);
const LazySpecialGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySpecialGroupListPage" */ "src/pages/Products/SpecialGroupList/SpecialGroupListPage"
    )
);
const LazyIVAListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyIVAListPage" */ "src/pages/Products/IVAList/IVAListPage"
    )
);
const LazyBrandListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBrandListPage" */ "src/pages/Products/BrandList/BrandListPage"
    )
);
const LazyProductListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyProductListPage" */ "src/pages/Products/ProductList/ProductListPage"
    )
);
const LazyProductContributionMarginListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyProductContributionMarginListPage" */ "src/pages/Products/ProductContributionMarginList/ProductContributionMarginListPage"
    )
);
const LazyUploadInventoryAdjustmentListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyUploadInventoryAdjustmentListPage" */ "src/pages/Products/InventoryAdjustmentUploadList/InventoryAdjustmentUploadListPage"
    )
);
const LazyUploadInventoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyUploadInventoryListPage" */ "src/pages/Products/InventoryUploadList/InventoryUploadListPage"
    )
);
const LazyPurchaseRequestListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPurchaseRequestListPage" */ "src/pages/Products/PurchaseRequestList/PurchaseRequestListPage"
    )
);
const LazyPurchaseReceiptListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPurchaseReceiptListPage" */ "src/pages/Products/PurchaseReceiptList/PurchaseReceiptListPage"
    )
);
const LazyPurchaseRequisitionListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPurchaseRequisitionListPage" */ "src/pages/Products/RequisitionList/RequisitionListPage"
    )
);
const LazyImportCostListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyImportCostListPage" */ "src/pages/Products/ImportCostList/ImportCostListPage"
    )
);
const LazyQuotationListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyQuotationListPage" */ "src/pages/Products/QuotationList/QuotationListPage"
    )
);
const LazyMinMaxAlertListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMinMaxAlertListPage" */ "src/pages/Products/MinMaxAlertList/MinMaxAlertListPage"
    )
);
const LazyWarehouseTransferListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarehouseTransferListPage" */ "src/pages/Products/WarehouseTransferList/WarehouseTransferListPage"
    )
);
const LazyAvailableInventoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAvailableInventoryListPage" */ "src/pages/Products/AvailableInventoryList/AvailableInventoryListPage"
    )
);
const LazyValorizationInventoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyValorizationInventoryListPage" */ "src/pages/Products/ValorizationInventoryList/ValorizationInventoryListPage"
    )
);
const LazyInventoryMovementsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyInventoryMovementsListPage" */ "src/pages/Products/InventoryMovementsList/InventoryMovementsListPage"
    )
);
const LazyBaseUnitMeasureListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBaseUnitMeasureListPage" */ "src/pages/Products/BaseUnitMeasureList/BaseUnitMeasureListPage"
    )
);
const LazyAssortmentTreeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAssortmentTreeListPage" */ "src/pages/Products/AssortmentTreeList/AssortmentTreeListPage"
    )
);
const LazyProductTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyProductTypeListPage" */ "src/pages/Products/ProductTypeList/ProductTypeListPage"
    )
);
const LazyWarrantyListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarrantyListPage" */ "src/pages/Products/WarrantyList/WarrantyListPage"
    )
);
const LazyWarrantyFormatListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarrantyFormatListPage" */ "src/pages/Products/WarrantyFormatList/WarrantyFormatListPage"
    )
);
const LazyWarrantyModelListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarrantyModelListPage" */ "src/pages/Products/WarrantyModelList/WarrantyModelListPage"
    )
);
const LazyWarrantyTreeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarrantyTreeListPage" */ "src/pages/Products/WarrantyTreeList/WarrantyTreeListPage"
    )
);
const LazyVendorListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyVendorListPage" */ "src/pages/Products/VendorList/VendorListPage"
    )
);

/* Lazy Maintenances Pages. */
const LazyPageListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPageListPage" */ "src/pages/Maintenance/PageList/PageListPage"
    )
);
const LazyMenuItemListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMenuItemListPage" */ "src/pages/Maintenance/MenuItemList/MenuItemListPage"
    )
);
const LazyMenuGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMenuGroupListPage" */ "src/pages/Maintenance/MenuGroupList/MenuGroupListPage"
    )
);
const LazyActionListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyActionListPage" */ "src/pages/Maintenance/ActionList/ActionListPage"
    )
);
const LazyMainMenuListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMainMenuListPage" */ "src/pages/Maintenance/MainMenuList/MainMenuListPage"
    )
);
const LazyUserListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyUserListPage" */ "src/pages/Maintenance/UserList/UserListPage"
    )
);
const LazyRoleListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyRoleListPage" */ "src/pages/Maintenance/RoleList/RoleListPage"
    )
);
const LazyUserTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyUserTypeListPage" */ "src/pages/Maintenance/UserTypeList/UserTypeListPage"
    )
);
const LazyFingerReasonListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyFingerReasonListPage" */ "src/pages/Maintenance/FingerReasonList/FingerReasonListPage"
    )
);
const LazySupervisorPermissionListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySupervisorPermissionListPage" */ "src/pages/Maintenance/SupervisorPermissionList/SupervisorPermissionListPage"
    )
);
const LazyUserAHListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyUserAHListPage" */ "src/pages/Maintenance/UserAHList/UserAHListPage"
    )
);
const LazySpecialAccessUserListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySpecialAccessUserListPage" */ "src/pages/Maintenance/SpecialAccessUserList/SpecialAccessUserListPage"
    )
);
const LazyDualPaymentsCompanyListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDualPaymentsCompanyListPage" */ "src/pages/Maintenance/DualPaymentsCompanyList/DualPaymentsCompanyListPage"
    )
);
const LazyDualPaymentsCompanyDetailPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDualPaymentsCompanyDetailPage" */ "src/pages/Maintenance/DualPaymentsCompanyDetail/DualPaymentsCompanyDetailPage"
    )
);

/* Lazy Prices Pages. */
const LazyPriceGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPriceGroupListPage" */ "src/pages/Prices/PriceGroupList/PriceGroupListPage"
    )
);
const LazyPaymentMethodListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentMethodListPage" */ "src/pages/Prices/PaymentMethodList/PaymentMethodListPage"
    )
);
const LazyBINListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBINListPage" */ "src/pages/Prices/BINList/BINListPage"
    )
);
const LazyPaymentMethodGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentMethodGroupListPage" */ "src/pages/Prices/PaymentMethodGroupList/PaymentMethodGroupListPage"
    )
);
const LazyGiftCardListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyGiftCardListPage" */ "src/pages/Prices/GiftCardList/GiftCardListPage"
    )
);
const LazyBankListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBankListPage" */ "src/pages/Prices/BankList/BankListPage"
    )
);
const LazyBankDepositListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBankDepositListPage" */ "src/pages/Prices/BankDepositList/BankDepositListPage"
    )
);
const LazyBankAccountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBankAccountListPage" */ "src/pages/Prices/BankAccountList/BankAccountListPage"
    )
);
const LazyVendorBankAccountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyVendorBankAccountListPage" */ "src/pages/Prices/VendorBankAccountList/VendorBankAccountListPage"
    )
);
const LazyVoucherListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyVoucherListPage" */ "src/pages/Prices/VoucherList/VoucherListPage"
    )
);
const LazyPrcVoucherTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyVoucherTypeListPage" */ "src/pages/Prices/VoucherTypeList/VoucherTypeListPage"
    )
);
const LazyTermBCListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTermBCListPage" */ "src/pages/Prices/TermBCList/TermBCListPage"
    )
);

/* Lazy Stores Pages. */
const LazyCompanyListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCompanyListPage" */ "src/pages/Stores/CompanyList/CompanyListPage"
    )
);
const LazyStoreListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyStoreListPage" */ "src/pages/Stores/StoreList/StoreListPage"
    )
);
const LazyServiceCategoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyServiceCategoryListPage" */ "src/pages/Stores/ServiceCategoryList/ServiceCategoryListPage"
    )
);
const LazyTransactionTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTransactionTypeListPage" */ "src/pages/Stores/TransactionTypesList/TransactionTypesListPage"
    )
);
/* Lazy Warehouse Pages. */
const LazyWarehouseListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWarehouseListPage" */ "src/pages/Stores/WarehouseList/WarehouseListPage"
    )
);
const LazyEmployeeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyEmployeeListPage" */ "src/pages/Stores/EmployeeList/EmployeeListPage"
    )
);
const LazyEmployeeTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyEmployeeTypeListPage" */ "src/pages/Stores/EmployeeTypeList/EmployeeTypeListPage"
    )
);
const LazyAccountSubcategoryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountSubcategoryListPage" */ "src/pages/Stores/AccountSubcategoryList/AccountSubcategoryListPage"
    )
);
const LazyIncomeExpenseAccountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyIncomeExpenseAccountListPage" */ "src/pages/Stores/IncomeExpenseAccountList/IncomeExpenseAccountListPage"
    )
);
const LazyLedgerAccountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLedgerAccountListPage" */ "src/pages/Stores/LedgerAccountList/LedgerAccountListPage"
    )
);
const LazySaleListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySaleListPage" */ "src/pages/Stores/SaleList/SaleListPage"
    )
);
const LazySaleReturnReasonListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySaleReturnReasonListPage" */ "src/pages/Stores/SaleReturnReasonList/SaleReturnReasonListPage"
    )
);
const LazyPrintReasonListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPrintReasonListPage" */ "src/pages/Stores/PrintReasonList/PrintReasonListPage"
    )
);

const LazySaleStatusListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySaleListPage" */ "src/pages/Stores/SaleStatusList/SaleStatusListPage"
    )
);

/*Lazy POS Pages. */
const LazyTerminalListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTerminalListPage" */ "src/pages/POS/TerminalList/TerminalListPage"
    )
);
const LazyMenuProductListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMenuProductListPage" */ "src/pages/POS/MenuProductList/MenuProductListPage"
    )
);

const LazyPrinterListPag = lazy(
  () =>
    import(
      "src/pages/POS/PrinterList/PrinterListPage"
    )
)

/* Lazy General Pages. */
const LazyBusinessPostingGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyBusinessPostingGroupListPage" */ "src/pages/General/BusinessPostingGroupList/BusinessPostingGroupListPage"
    )
);
const LazyIVAPostingGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyIVAPostingGroupListPage" */ "src/pages/Products/IVAPostingGroupList/IVAPostingGroupListPage"
    )
);
const LazyPaymentTermListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentTermListPage" */ "src/pages/General/PaymentTermList/PaymentTermListPage"
    )
);
const LazyAttributeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentTermListPage" */ "src/pages/General/AttributeList/AttributeListPage"
    )
);
const LazyCountryListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCountryListPage" */ "src/pages/General/CountryList/CountryListPage"
    )
);
const LazyStateListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyStateListPage" */ "src/pages/General/StateList/StateListPage"
    )
);
const LazyCityListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCityListPage" */ "src/pages/General/CityList/CityListPage"
    )
);
const LazyCurrencyListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCurrencyListPage" */ "src/pages/General/CurrencyList/CurrencyListPage"
    )
);
const LazyVendorPostingGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyVendorPostingGroupListPage" */ "src/pages/General/VendorPostingGroupList/VendorPostingGroupListPage"
    )
);
const LazySerieListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySerieListPage" */ "src/pages/General/SerieList/SerieListPage"
    )
);
const LazyTimeMeasurementListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTimeMeasurementListPage" */ "src/pages/General/TimeMeasurementList/TimeMeasurementListPage"
    )
);

/* Lazy Configurations Pages. */
const LazyModuleListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyModuleListPage" */ "src/pages/General/ModuleList/ModuleListPage"
    )
);

/* Lazy Configurations Pages. */
const LazyConfigurationComisionListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyConfigurationComisionListPage" */ "src/pages/General/ConfigurationComisionList/ConfigurationComisionListPage"
    )
);
const LazySerieSetupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazySerieSetupListPage" */ "src/pages/General/SerieSetupList/SerieSetupListPage"
    )
);
const LazyCashDeclarationListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCashDeclarationListPage" */ "src/pages/General/CashDeclarationList/CashDeclarationListPage"
    )
);
const LazyConfigurationListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyConfigurationListPage" */ "src/pages/General/ConfigurationList/ConfigurationListPage"
    )
);
const LazyConfigurationPrintCopiesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyConfigurationPrintCopiesListPage" */ "src/pages/POS/DocumentPrintCopyList/DocumentPrintCopyListPage"
    )
);
const LazyMovementTypeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyConfigurationListPage" */ "src/pages/Inventory/MovementTypeList/MovementTypeListPage"
    )
);
// const LazyInventoryCreateListPage = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "LazyConfigurationListPage" */ "src/pages/Inventory/InventoryStoreList/InventoryStoreListPage"
//     )
// );
const LazyInfoCodeListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyInfoCodeListPage" */ "src/pages/General/InfoCodeList/InfoCodeListPage"
    )
);

/* Lazy Offers Pages. */
const LazyValidationPeriodListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyValidationPeriodListPage" */ "src/pages/Offers/ValidationPeriodList/ValidationPeriodListPage"
    )
);
const LazyOfferListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyOfferListPage" */ "src/pages/Offers/OfferList/OfferListPage"
    )
);
const LazyMixAndMatchListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyMixAndMatchListPage" */ "src/pages/Offers/MixAndMatchList/MixAndMatchListPage"
    )
);
const LazyOfferOnDiscountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyOfferOnDiscountListPage" */ "src/pages/Offers/OfferOnDiscountList/OfferOnDiscountListPage"
    )
);
const LazyOfferPriorityListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyOfferPriorityListPage" */ "src/pages/Offers/OfferPriorityList/OfferPriorityListPage"
    )
);
const LazyEmployeeDiscountListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyEmployeeDiscountListPage" */ "src/pages/Offers/EmployeeDiscountList/EmployeeDiscountListPage"
    )
);
const LazyCouponListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCouponListPage" */ "src/pages/Offers/CouponList/CouponListPage"
    )
);
const LazyCouponIssuerListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCouponIssuerListPage" */ "src/pages/Offers/CouponIssuerList/CouponIssuerListPage"
    )
);

/* Lazy Reports Pages. */
const LazyCashReceiptReportPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCashReceiptReportPage" */ "src/pages/Reports/CashReceiptReportPage/CashReceiptReportPage"
    )
);

/* Lazy CrediDiunsa Pages. */
const LazyOfferOnDiscountConfigListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCashReceiptReportPage" */ "src/pages/CrediDiunsa/OfferOnDiscountConfigList/OfferOnDiscountConfigListPage"
    )
);

/* Lazy CrediDiunsa Pages. */
const LazyConfigurationMenuListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCashReceiptReportPage" */ "src/pages/General/ConfigurationMenuList/ConfigurationMenuListPage"
    )
);

const LazyDocFormatListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDocFormatListPage" */ "src/pages/DOC/FormatList/FormatListPage"
    )
);

/* Lazy Human Resources */
const LazyDeparmentTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDeparmentTypesListPage" */ "src/pages/HumanResources/DeparmentTypes/DeparmentTypesList/DeparmentTypesListPage"
    )
);

const LazyWorkPositionTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWorkPositionTypesListPage" */ "src/pages/HumanResources/WorkPositionTypes/WorkPositionTypesList/WorkPositionTypesListPage"
    )
);

const LazyWorkAreasListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWorkAreasListPage" */ "src/pages/HumanResources/WorkAreas/WorkAreasList/WorkAreasListPage"
    )
);

const LazyDepartmentsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWorkAreasListPage" */ "src/pages/HumanResources/Departments/DepartmentsList/DepartmentsListPage"
    )
);

const LazyWorkPositionsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyWorkPositionListPage" */ "src/pages/HumanResources/WorkPosition/WorkPositionsList/WorkPositionsListPage"
    )
);

const LazyCostCentersListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyCostCenterListPage" */ "src/pages/HumanResources/CostCenter/CostCentersList/CostCentersListPage"
    )
);

const LazyPositionsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPositionListPage" */ "src/pages/HumanResources/Positions/PositionsList/PositionsListPage"
    )
);

const LazyTerminationCategoriesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTerminationCategorieListPage" */ "src/pages/HumanResources/TerminationCategories/TerminationCategoriesList/TerminationCategoriesListPage"
    )
);

const LazyTerminationReasonsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTerminationReasonListPage" */ "src/pages/HumanResources/TerminationReasons/TerminationReasonsList/TerminationReasonsListPage"
    )
);

const LazyContractTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyContractTypesListPage" */ "src/pages/HumanResources/ContractTypes/ContractTypesList/ContractTypesListPage"
    )
);

const LazyDocumentTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyDocumentTypesListPage" */ "src/pages/HumanResources/DocumentTypes/DocumentTypesList/DocumentTypesListPage"
    )
);

const LazyParentTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyParentTypesListPage" */ "src/pages/HumanResources/ParentTypes/ParentTypesList/ParentTypesListPage"
    )
);

const LazyInfoEmployeesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyInfoEmployeesListPage" */ "src/pages/HumanResources/InfoEmployees/InfoEmployeesList/InfoEmployeesListPage"
    )
);

const LazyContributionTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyContributionTypesListPage" */ "src/pages/HumanResources/ContributionTypes/ContributionTypesList/ContributionTypesListPage"
    )
);

const LazyContributionEmployeesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyContributionEmployeesListPage" */ "src/pages/HumanResources/ContributionEmployees/ContributionEmployeesList/ContributionEmployeesListPage"
    )
);

const LazyAccountTypesListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAccountTypesListPage" */ "src/pages/HumanResources/AccountTypes/AccountTypesList/AccountTypesListPage"
    )
);

const LazyPaymentMethodsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentMethodsListPage" */ "src/pages/HumanResources/PaymentMethods/PaymentMethodsList/PaymentMethodsListPage"
    )
);

const LazyModifierGroupListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyPaymentMethodsListPage" */ "src/pages/Products/ModifierGroupList/ModifierGroupListPage"
    )
);

const LazyAreaListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyAreaListPage" */ "src/pages/Products/AreaList/AreaListPage"
    )
);

const LazyTableListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyTableListPage" */ "src/pages/Products/TableList/TableListPage"
    )
);

const LazyComandasPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyComandasPage" */ "src/pages/Configuration/Comandas/ComandasPage"
    )
);

const userRoutes: Array<RouteProps> = [
  //User Profile
  { path: "/profile", component: userProfile },
  //Dashboard
  { path: "/dashboard", component: Dashboard },
  //Company
  {
    path: CMP_ATTRIBUTE_VALUE_LIST,
    component: LazyAttributeValueListPage,
  },
  // Accounting
  {
    path: ACC_DAILY_INVOICES_REPORT_LIST,
    component: LazyAccountDailyInvoicesReportListPage,
  },
  {
    path: ACC_INVOICES_REPORT_LIST,
    component: LazyAccountInvoicesReportListPage,
  },
  {
    path: ACC_STATUS_RESULT_REPORT_LIST,
    component: LazyAccountStatusResultReportListPage,
  },
  {
    path: ACC_INVOICESXEMPLOYEE_GRUOPEDREPORT_LIST,
    component: LazyAccountInvoicesXEmployeeReportGroupedListPage,
  },
  {
    path: ACC_INVOICESXEMPLOYEE_REPORT_LIST,
    component: LazyAccountInvoicesXEmployeeReportListPage,
  },
  {
    path: ACC_OVERDUE_VENDOR_INVOICES_LIST,
    component: LazyAccountOverDueInvoicesPartnerListPage,
  },
  {
    path: ACC_OVERDUE_CUSTOMER_INVOICES_LIST,
    component: LazyAccountOverDueInvoicesCustomerListPage,
  },
  {
    path: ACC_JOURNAL_LIST,
    component: LazyAccountJournalListPage,
  },
  {
    path: ACC_ENTRIES,
    component: LazyAccountEntriesListPage,
  },
  {
    path: ACC_MANUAL_MOVEMENTS,
    component: LazyAccountManualMovementListPage,
  },
  {
    path: ACC_EXPENSES_LIST,
    component: LazyAccountExpensesListPage,
  },
  {
    path: ACC_INVOICES_LIST,
    component: LazyAccountInvoicesListPage,
  },
  {
    path: ACC_QUOTATION_INVOICES_LIST,
    component: LazyAccountQuotationInvoicesListPage,
  },
  {
    path: ACC_VENDOR_PAYMENT_INVOICES_LIST,
    component: LazyAccountPaymentInvoicesListPage,
  },
  {
    path: ACC_EXPENSES_PAYMENT_LIST,
    component: LazyAccountPaymentExpensesListPage,
  },
  {
    path: ACC_QUOTATION_PAYMENT_INVOICES_LIST,
    component: LazyAccountQuotationPaymentInvoicesListPage,
  },
  {
    path: INVOICE_TYPES_LIST,
    component: LazyInvoiceTypesListPage,
  },
  {
    path: ERP_CREDIT_NOTES_LIST,
    component: LazyERPCreditNotesListPage,
  },
  {
    path: ERP_CREDIT_NOTES_REPORT_LIST,
    component: LazyERPCreditNotesReportListPage,
  },
  {
    path: POS_CLOSURE_REPORT_LIST,
    component: LazyClosurePOSReportListPage,
  },
  {
    path: RPT_PRODUCTS_SALES_REPORT,
    component: LazySalesByProductReportListPage,
  },
  {
    path: RPT_SALES_BY_CUSTOMER_REPORT,
    component: LazySalesByCustomerGroupedReportListPage,
  },
  //Customers
  {
    path: CUS_CUSTOMER_LIST,
    component: LazyCustomerListPage,
  },
  {
    path: CUS_MEMBER_CLUB_LIST,
    component: LazyMemberClubListPage,
  },
  {
    path: CUS_CUSTOMER_MEMBER_CLUB_LIST,
    component: LazyCustomerXMemberClubListPage,
  },
  {
    path: CUS_GROUP_LIST,
    component: LazyCustomerGroupListPage,
  },
  {
    path: CUS_POSTING_GROUP_LIST,
    component: LazyPostingGroupListPage,
  },
  {
    path: CUS_MEMBER_CLUB_CARD_SPOOL_LIST,
    component: LazyMemberClubCardSpoolListPage,
  },
  {
    path: CUS_MEMBER_CLUB_SCHEME_LIST,
    component: LazyMemberClubSchemeListPage,
  },
  //Products
  {
    path: PRO_PRODUCT_LIST,
    component: LazyProductListPage,
  },
  {
    path: MODIFIER_GROUP_LIST,
    component: LazyModifierGroupListPage,
  },
  {
    path: PRO_PRODUCT_CONTRIBUTION_MARGIN_LIST,
    component: LazyProductContributionMarginListPage,
  },
  {
    path: UPLOAD_INVENTORY_ADJUSTMENT_LIST,
    component: LazyUploadInventoryAdjustmentListPage,
  },
  {
    path: UPLOAD_INVENTORY_LIST,
    component: LazyUploadInventoryListPage,
  },
  {
    path: PRO_PURCHASE_REQUEST_LIST,
    component: LazyPurchaseRequestListPage,
  },
  {
    path: PRO_PURCHASE_RECEIPT_LIST,
    component: LazyPurchaseReceiptListPage,
  },
  {
    path: PRO_REQUISITION_LIST,
    component: LazyPurchaseRequisitionListPage,
  },
  {
    path: PRO_BILL_LADING_LIST,
    component: LazyBillLadingListPage,
  },
  {
    path: PRO_IMPORT_COST_LIST,
    component: LazyImportCostListPage,
  },
  {
    path: PRO_QUOTATION_LIST,
    component: LazyQuotationListPage,
  },
  {
    path: PRO_MINMAX_ALERT_LIST,
    component: LazyMinMaxAlertListPage,
  },
  {
    path: INV_WAREHOUSE_TRANSFER_LIST,
    component: LazyWarehouseTransferListPage,
  },
  {
    path: INV_VALORIZATION_PRODUCTS_LIST,
    component: LazyValorizationInventoryListPage,
  },
  {
    path: INV_AVAILABLE_PRODUCTS_LIST,
    component: LazyAvailableInventoryListPage,
  },
  {
    path: INV_MOVEMENTS_PRODUCTS_LIST,
    component: LazyInventoryMovementsListPage,
  },
  {
    path: PRO_BASE_UNIT_MEASURE_LIST,
    component: LazyBaseUnitMeasureListPage,
  },
  {
    path: PRO_CATEGORY_LIST,
    component: LazyCategoryListPage,
  },
  {
    path: PRO_DIVISION_LIST,
    component: LazyDivisionListPage,
  },
  {
    path: PRO_GROUP_LIST,
    component: LazyProductGroupListPage,
  },
  {
    path: PRO_IVA_LIST,
    component: LazyIVAListPage,
  },
  {
    path: PRO_SPECIAL_GROUP_LIST,
    component: LazySpecialGroupListPage,
  },
  {
    path: PRO_BRAND_LIST,
    component: LazyBrandListPage,
  },


  {
    path: MAINTENANCE_AREA_LIST,
    component: LazyAreaListPage,
  },
   {
    path: MAINTENANCE_TABLE_LIST,
    component: LazyTableListPage,
  },
  {
    path: MAINTENANCE_COMMANDS_LIST,
    component: LazyComandasPage,
  },



  {
    path: PRO_INVENTORY_GROUP_LIST,
    component: LazyInventoryGroupListPage,
  },
  {
    path: PRO_ASSORTMENT_TREE_LIST,
    component: LazyAssortmentTreeListPage,
  },
  {
    path: PRO_TYPE_LIST,
    component: LazyProductTypeListPage,
  },
  {
    path: PRO_WARRANTY_LIST,
    component: LazyWarrantyListPage,
  },
  {
    path: PRO_WARRANTY_FORMAT_LIST,
    component: LazyWarrantyFormatListPage,
  },
  {
    path: PRO_WARRANTY_MODEL_LIST,
    component: LazyWarrantyModelListPage,
  },
  {
    path: PRO_WARRANTY_TREE_LIST,
    component: LazyWarrantyTreeListPage,
  },
  {
    path: PRO_VENDOR_LIST,
    component: LazyVendorListPage,
  },
  //Maintenance
  { path: MAINTENANCE_PAGES_LIST, component: LazyPageListPage },
  {
    path: MAINTENANCE_MENU_OPTIONS_LIST,
    component: LazyMenuItemListPage,
  },
  { path: MAINTENANCE_MENU_GROUPS_LIST, component: LazyMenuGroupListPage },
  { path: MAINTENANCE_ACTIONS_LIST, component: LazyActionListPage },
  { path: MAINTENANCE_MENUS_LIST, component: LazyMainMenuListPage },

  { path: MAINTENANCE_USERS_LIST, component: LazyUserListPage },
  { path: MAINTENANCE_ROLES_LIST, component: LazyRoleListPage },
  {
    path: MAINTENANCE_USER_TYPES_LIST,
    component: LazyUserTypeListPage,
  },
  {
    path: USR_FINGER_REASON_LIST,
    component: LazyFingerReasonListPage,
  },
  {
    path: USR_SUPERVISOR_PERMISSION_LIST,
    component: LazySupervisorPermissionListPage,
  },
  {
    path: USR_USER_AH_LIST,
    component: LazyUserAHListPage,
  },
  {
    path: USR_SPECIAL_ACCESS_USER_LIST,
    component: LazySpecialAccessUserListPage,
  },
  {
    path: USR_DUALPAYMENTS_COMPANY_LIST,
    component: LazyDualPaymentsCompanyListPage,
  },
  {
    path: USR_DUALPAYMENTS_COMPANY_DETAIL,
    component: LazyDualPaymentsCompanyDetailPage,
  },
  //Prices
  {
    path: PRC_PRICE_GROUP_LIST,
    component: LazyPriceGroupListPage,
  },
  {
    path: PRC_PAYMENT_METHOD_LIST,
    component: LazyPaymentMethodListPage,
  },
  {
    path: PRC_BIN_LIST,
    component: LazyBINListPage,
  },
  {
    path: PRC_PAYMENT_METHOD_GROUP_LIST,
    component: LazyPaymentMethodGroupListPage,
  },
  {
    path: PRC_GIFT_CARD_LIST,
    component: LazyGiftCardListPage,
  },
  {
    path: PRC_BANK_LIST,
    component: LazyBankListPage,
  },
  {
    path: PRC_BANK_DEPOSIT_LIST,
    component: LazyBankDepositListPage,
  },
  {
    path: PRC_BANK_ACCOUNT_LIST,
    component: LazyBankAccountListPage,
  },
  {
    path: PRC_VENDOR_BANK_ACCOUNT_LIST,
    component: LazyVendorBankAccountListPage,
  },
  {
    path: PRC_VOUCHER_LIST,
    component: LazyVoucherListPage,
  },
  {
    path: PRC_VOUCHERTYPE_LIST,
    component: LazyPrcVoucherTypeListPage,
  },
  {
    path: PRC_TERM_BC_LIST,
    component: LazyTermBCListPage,
  },
  //Stores
  {
    path: STO_COMPANY_LIST,
    component: LazyCompanyListPage,
  },
  {
    path: STO_STORE_LIST,
    component: LazyStoreListPage,
  },
  {
    path: STO_SERVICE_CATEGORY_LIST,
    component: LazyServiceCategoryListPage,
  },
  {
    path: STO_TRANSACTION_TYPE_LIST,
    component: LazyTransactionTypeListPage,
  },
  {
    path: STO_WAREHOUSE_LIST,
    component: LazyWarehouseListPage,
  },
  {
    path: EMP_EMPLOYEE_LIST,
    component: LazyEmployeeListPage,
  },
  {
    path: EMP_EMPLOYEETYPE_LIST,
    component: LazyEmployeeTypeListPage,
  },
  {
    path: STO_ACCOUNT_SUBCATEGORY_LIST,
    component: LazyAccountSubcategoryListPage,
  },
  {
    path: STO_INCOME_EXPENSE_ACCOUNT_LIST,
    component: LazyIncomeExpenseAccountListPage,
  },
  {
    path: STO_LEDGER_ACCOUNT_LIST,
    component: LazyLedgerAccountListPage,
  },
  {
    path: SAL_SALE_LIST,
    component: LazySaleListPage,
  },
  {
    path: SAL_SALE_RETURN_REASON,
    component: LazySaleReturnReasonListPage,
  },
  {
    path: INV_PRINT_REASON,
    component: LazyPrintReasonListPage,
  },
  {
    path: SAL_SALESTATUS_LIST,
    component: LazySaleStatusListPage,
  },
  //POS
  {
    path: POS_TERMINAL_LIST,
    component: LazyTerminalListPage,
  },
  {
    path: POS_MENU_PRODUCT_LIST,
    component: LazyMenuProductListPage,
  },
  {
    path: POS_PRINTER_LIST,
    component: LazyPrinterListPag,
  },
  //General
  {
    path: CUS_BUS_POSTING_GROUP_LIST,
    component: LazyBusinessPostingGroupListPage,
  },
  {
    path: PRO_IVA_POSTING_GROUP_LIST,
    component: LazyIVAPostingGroupListPage,
  },
  {
    path: GEN_PAYMENT_TERM_LIST,
    component: LazyPaymentTermListPage,
  },
  {
    path: GEN_ATTRIBUTE_LIST,
    component: LazyAttributeListPage,
  },
  {
    path: LOC_COUNTRY_LIST,
    component: LazyCountryListPage,
  },
  {
    path: LOC_STATE_LIST,
    component: LazyStateListPage,
  },
  {
    path: LOC_CITY_LIST,
    component: LazyCityListPage,
  },
  {
    path: BUS_CURRENCY_LIST,
    component: LazyCurrencyListPage,
  },
  {
    path: PRO_VENDOR_POSTING_GROUP_LIST,
    component: LazyVendorPostingGroupListPage,
  },
  {
    path: BUS_SERIE_LIST,
    component: LazySerieListPage,
  },
  {
    path: TIME_MEASUREMENT_LIST,
    component: LazyTimeMeasurementListPage,
  },
  //Configurations
  {
    path: CFG_MODULE_LIST,
    component: LazyModuleListPage,
  },
  {
    path: CFG_CONFIGURATION_COMISION_LIST,
    component: LazyConfigurationComisionListPage,
  },
  {
    path: CFG_SERIE_SETUP_LIST,
    component: LazySerieSetupListPage,
  },
  {
    path: CFG_CASH_DECLARATION_LIST,
    component: LazyCashDeclarationListPage,
  },
  {
    path: CFG_CONFIGURATION_LIST,
    component: LazyConfigurationListPage,
  },
  {
    path: CFG_CONFIGURATIONPRINTCOPIES_LIST,
    component: LazyConfigurationPrintCopiesListPage,
  },
  {
    path: INV_MOV_TYPE_LIST,
    component: LazyMovementTypeListPage,
  },
  // {
  //   path: INV_CREATE_LIST,
  //   component: LazyInventoryCreateListPage,
  // },
  {
    path: INF_INFO_CODE_LIST,
    component: LazyInfoCodeListPage,
  },
  //Ofertas
  {
    path: OFF_VALIDATION_PERIOD_LIST,
    component: LazyValidationPeriodListPage,
  },
  {
    path: OFF_OFFER_LIST,
    component: LazyOfferListPage,
  },
  {
    path: OFF_MIX_AND_MATCH_LIST,
    component: LazyMixAndMatchListPage,
  },
  {
    path: OFF_OFFER_ON_DISCOUNT_LIST,
    component: LazyOfferOnDiscountListPage,
  },
  {
    path: OFF_OFFER_PRIORITY_LIST,
    component: LazyOfferPriorityListPage,
  },
  {
    path: OFF_EMPLOYEE_DISCOUNT_LIST,
    component: LazyEmployeeDiscountListPage,
  },
  {
    path: OFF_COUPON_LIST,
    component: LazyCouponListPage,
  },
  {
    path: OFF_COUPON_ISSUER_LIST,
    component: LazyCouponIssuerListPage,
  },
  //Reports
  {
    path: RPT_CASH_RECEIPT_REPORT,
    component: LazyCashReceiptReportPage,
  },
  //CrediDiunsa
  {
    path: OFF_OFFER_ON_DISCOUNT_CONFIGS_LIST,
    component: LazyOfferOnDiscountConfigListPage,
  },
  // Configuration Menu
  {
    path: CONFIGURATION_MENU_LIST,
    component: LazyConfigurationMenuListPage,
  },
  // Configuration Menu
  {
    path: DOC_FORMAT_LIST,
    component: LazyDocFormatListPage,
  },
  //Human Resources Menu
  {
    path: GOR_DEPARMENT_TYPE_LIST,
    component: LazyDeparmentTypesListPage,
  },
  {
    path: GOR_WORK_POSITION_TYPE_LIST,
    component: LazyWorkPositionTypesListPage,
  },
  {
    path: GOR_WORK_AREA_LIST,
    component: LazyWorkAreasListPage,
  },
  {
    path: GOR_DEPARTMENT_LIST,
    component: LazyDepartmentsListPage,
  },
  {
    path: GOR_WORK_POSITION_LIST,
    component: LazyWorkPositionsListPage,
  },
  {
    path: GOR_COST_CENTER_LIST,
    component: LazyCostCentersListPage,
  },
  {
    path: GOR_POSITION_LIST,
    component: LazyPositionsListPage,
  },
  {
    path: GEX_TERMINATION_CATEGORY_LIST,
    component: LazyTerminationCategoriesListPage,
  },
  {
    path: GEX_TERMINATION_REASON_LIST,
    component: LazyTerminationReasonsListPage,
  },
  {
    path: GEX_CONTRACT_TYPE_LIST,
    component: LazyContractTypesListPage,
  },
  {
    path: GEX_DOCUMENT_TYPE_LIST,
    component: LazyDocumentTypesListPage,
  },
  {
    path: GEX_PARENT_TYPE_LIST,
    component: LazyParentTypesListPage,
  },
  {
    path: GEX_INFO_EMPLOYEE_LIST,
    component: LazyInfoEmployeesListPage,
  },
  {
    path: GEX_CONTRIBUTION_TYPE_LIST,
    component: LazyContributionTypesListPage,
  },
  {
    path: GEX_CONTRIBUTION_EMPLOYEE_LIST,
    component: LazyContributionEmployeesListPage,
  },
  {
    path: GEX_ACCOUNT_TYPE_LIST,
    component: LazyAccountTypesListPage,
  },
  {
    path: GEX_PAYMENT_METHOD_LIST,
    component: LazyPaymentMethodsListPage,
  },

  //Utility pages
  { path: UNATHORIZED, component: Unathorized },
  { path: NOT_FOUND, component: NotFound },
  // this route should be at the end of all other routes
  { path: INIT, exact: true, component: () => <Redirect to="/dashboard" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: LOGIN_PAGE, component: LoginNew },
  { path: "/logout", component: Logout },
  { path: FORGETPASS, component: ForgetPasswordNew },
  // { path: "/register", component: Register },
];

export { userRoutes, authRoutes };
